@if (recentPerformanceObservable | async; as recentPerformance) {
  <main class="container">
    <header>
      <h1 class="d-inline-block">Recent Performance</h1>
      <div class="form-inline float-right">
        Filter By
        <div class="custom-control custom-checkbox custom-control-inline">
          <input type="checkbox" class="custom-control-input" id="incorrectOnly"
            [formControl]="performanceControl.get('onlyIncorrect')">
          <label class="custom-control-label" for="incorrectOnly">Incorrect</label>
        </div>
        <div class="custom-control custom-checkbox custom-control-inline">
          <input type="checkbox" class="custom-control-input" id="filterFlagged"
            [formControl]="performanceControl.get('flagged')">
          <label class="custom-control-label" for="filterFlagged">Flagged</label>
        </div>
        <select class="custom-select custom-select-sm d-inline-block" [formControl]="performanceControl.get('subject')">
          <option selected value="All">All Subjects</option>
          <option value="ACT English">ACT English</option>
          <option value="ACT Math">ACT Math</option>
          <option value="ACT Reading">ACT Reading</option>
          <option value="ACT Science">ACT Science</option>
          <option value="MyGame">MyGame</option>
        </select>
      </div>
    </header>
    @if (exercisePerformanceMetrics && recentPerformance.exercisesPerformance && recentPerformance.exercisesPerformance.length) {
      <div ngbAccordion class="exercises" [closeOthers]="true" [destroyOnHide]="false" [animation]="false">
        @for (exercisePerformance of recentPerformance.exercisesPerformance; track exercisePerformance.id; let i = $index) {
          <div [ngbAccordionItem]="'' + exercisePerformance.id" [collapsed]="i !== 0">
            <h2 ngbAccordionHeader>
              <button ngbAccordionButton>
                <strong>{{exercisePerformance.exerciseTitle}}</strong> | {{exercisePerformance.lessonTitle}}<br/>
                @if (exercisePerformanceMetrics.get(exercisePerformance.exerciseId)) {
                  <span>
                    First Score: {{exercisePerformanceMetrics.get(exercisePerformance.exerciseId).firstScore}}/{{exercisePerformanceMetrics.get(exercisePerformance.exerciseId).firstScoreAttempted}}
                    &nbsp;|&nbsp;
                    Last Score: {{exercisePerformanceMetrics.get(exercisePerformance.exerciseId).lastScore}}/{{exercisePerformanceMetrics.get(exercisePerformance.exerciseId).lastScoreAttempted}}
                    &nbsp;|&nbsp;
                    Best Score: {{exercisePerformanceMetrics.get(exercisePerformance.exerciseId).bestScore}}/{{exercisePerformanceMetrics.get(exercisePerformance.exerciseId).bestScoreAttempted}}
                  </span>
                }
              </button>
            </h2>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <ng-template>
                  <table class="table">
                    <thead class="thead-dark">
                      <tr>
                        <th scope="col" style="width: 33.33%">Problem</th>
                        <th scope="col" style="width: 16.66%">Topic</th>
                        <th scope="col" style="width: 16.66%">Time</th>
                        <th scope="col" style="width: 8.33%">Correct</th>
                        <th scope="col" style="width: 8.33%">Flagged</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (problemProgress of exercisePerformance.problemProgress; track problemProgress) {
                        <tr>
                          <th scope="row"><a (click)="openProblemModal(content, problemProgress)">{{problemProgress.problemTitle}}</a></th>
                          <td>{{problemProgress.topicDisplayName}}</td>
                          <td>{{problemProgress.time | time}}</td>
                          <td>@if (problemProgress.isCorrect) {
                            <i class="fa fa-check-circle"></i>
                          }</td>
                          <td>@if (problemProgress.reviewFlagged) {
                            <i class="fa fa-check-circle"></i>
                          }</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </ng-template>
              </div>
            </div>
          </div>
        }
      </div>
      <aside class="float-right">
        Jump To Page
        <select class="custom-select custom-select-sm" [formControl]="performanceControl.get('page')">
          <!--Showing one more that the current index-->
          @for (item of recentPerformance.totalCount | paginationHelper:limit; track item; let i = $index) {
            <option value={{i}}>
              {{i + 1}}
            </option>
          }
        </select>
      </aside>
    } @else {
      <h3 class="d-inline-block">Nothing recent to show</h3>
    }
  </main>
} @else {
  <app-spinner></app-spinner>
}

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ selectedProblem.title}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-8">
        <div class="problem-content sticky-top">
          <p><app-content-viewer [content]="selectedProblem.content"></app-content-viewer></p>

          <div id="problemHint" [ngbCollapse]="false">
            <div class="card">
              <div class="card-body">
                <p><app-content-viewer [content]="selectedProblem.explanation"></app-content-viewer></p>
              </div>
            </div>
          </div>
        </div>

        <div class="problem-passage">
          @if (selectedProblem.passage) {
            <app-content-viewer
            [content]="selectedProblem.passage.content"></app-content-viewer>
          }
        </div>
      </div>
      <div class="col-4 p-4">
        <h5>Answers</h5>
        <hr>
          <ul class="list-unstyled">
            <li class="answer-correct">
              <small>Correct Answer</small>
              <app-content-viewer [content]="selectedProblem.solutions[0].correctAnswer"></app-content-viewer></li>
              <li class="answer-selected">
                <small>Your Answer</small>
                <app-content-viewer [content]="selectedProblemPerformance.answer"></app-content-viewer></li>
              </ul>
            </div>
          </div>
        </div>
      </ng-template>

